import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import { RegularSection } from '@/components/Layouts'
import { getImageData } from '@/utilites/getImageData'
import { resolveHref } from '@/utilites/resolveHref'
import Link from 'next/link'

const CARD_SX = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    textDecoration: 'none',
    backgroundSize: 'cover',
    borderRadius: 5,
    minHeight: { xs: 300, md: 600 },
    p: 4,
}

interface Card {
    image?: string | Record<string, unknown>
    link?: string
    title?: string
    description?: string
}

interface Content {
    cards?: Card[]
}

interface S3_L2_3Props {
    content?: Content
    blockName?:string
}

const Index = (props: S3_L2_3Props) => {
    const { content = {} } = props
    const { cards = [] } = content
    return (
        <RegularSection aria-label='S3_L2_3' >
            <Grid
                container
                spacing={4}
            >
                {cards.map((card, index) => {
                    const { src } = getImageData(card.image)
                    return (
                    <Grid key={'S3_L2_3' + index} size={{ xs: 12, md: 6, lg: 4 }}>
                        <Link href={resolveHref(card.link)} style={{ textDecoration: 'none', display: 'block', width: '100%' }}>
                            <Box
                                sx={{
                                    ...CARD_SX,
                                    backgroundImage: src ? `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.9)), url(${src})` : 'none',
                                }}
                            >
                                <Typography
                                    variant='h2'
                                    color='info'
                                >
                                    {index < 10 ? '0' + Number(index+ 1)  : index}
                                </Typography>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'start',
                                        flexDirection: 'column',
                                        gap: 2,
                                        height: '40%',
                                    }}
                                >
                                    <Typography
                                        variant='h2'
                                        color='secondary'
                                    >
                                        {card.title}
                                    </Typography>
                                    <Typography
                                        variant='body1'
                                        color='secondary'
                                    >
                                        {card.description}
                                    </Typography>
                                </Box>
                            </Box>
                        </Link>
                    </Grid>
                )
                })}
            </Grid>
        </RegularSection>
    )
}

export default Index
